"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var route_path_1 = require("../../../../../constants/route_path");
var AGgrid_table_component_1 = require("../../../../../common/tables/AGgrid_table_component");
var api_service_1 = require("../../../../../api/api_service");
var react_query_1 = require("react-query");
var table_data_1 = require("../../../../../constants/table_data");
var react_paginate_1 = require("../../../../../common/react_pagination/react_paginate");
var array_helpers_1 = require("../../../../../utils/array_helpers");
var menu_constants_1 = require("../../../../../menuList/menu_constants");
var orc_api_service_1 = require("../../orc_management/orc_api_service");
var scf_service_1 = require("../scf_service");
var SCFRejectedList = function (_a) {
    var searchTerm = _a.searchTerm, isFilterButton = _a.isFilterButton, PageLimit = _a.PageLimit;
    var nav = (0, react_router_1.useNavigate)();
    var _b = React.useState(undefined), scfList = _b[0], setScfList = _b[1];
    var _c = React.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = React.useState(1), pageCount = _d[0], setpageCount = _d[1];
    var _e = React.useState(0), totalPageCount = _e[0], setTotalPageCount = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.SCF_Management);
    var editHandlere = function (event) {
        var evenType = event.event.target.className;
        var data = event.data;
        if (evenType.includes('icon-Vector')) {
            nav("/".concat(route_path_1.default.PATHS.scf_listing, "/").concat(route_path_1.default.PATHS.edit_scf, "/").concat(data.center_id));
        }
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var getSCFList = function (endPoint, payLoad, domain) {
        (0, orc_api_service_1.fetchORCList)(endPoint, payLoad, domain)
            .then(function (response) {
            console.log(response, 'count');
            setErrorMessage("");
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            var convertedData = (0, scf_service_1.convertSCFListingAPIResponse)(response.result);
            setScfList(convertedData);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err.message);
            setScfList([]);
        });
    };
    var refetch = (0, react_query_1.useQuery)(['SCF-list', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {
            search_string: searchTerm,
            page: currentPage,
            size: PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50,
            status: "".concat(scf_service_1.SCF_CLIENT_STATUS_OBJ.LEVEL_ONE_REJECTED, ",").concat(scf_service_1.SCF_CLIENT_STATUS_OBJ.LEVEL_TWO_REJECTED)
        };
        getSCFList(api_service_1.api_service.api_urls.SCF_LISTING, payload, process.env.APPROVAL_BASEURL);
    }).refetch;
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isFilterButton]);
    console.log(PageLimit, 'PageLimit', totalPageCount, pageCount, totalCount);
    return (React.createElement("div", { className: "custom-pagination-table" },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.SCF_REJECTED_LIST_COLUMNS, onRowClicked: editHandlere, rows: !features[menu_constants_1.FEATURE_CONSTANTS.SCF_LEVEL_1_2_REJECTED_LIST] ? scfList : [], pagination: false, errorMessage: !features[menu_constants_1.FEATURE_CONSTANTS.SCF_LEVEL_1_2_REJECTED_LIST] ? errorMessage : 'Do not have this feature accesss' }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: scfList === null || scfList === void 0 ? void 0 : scfList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value })));
};
exports.default = SCFRejectedList;
